import CryptoJS from 'crypto-js'
export default {
  data () {
    return {
      plainString: 'Hello World',
      encryptsecret: 'aNq8cL5xAbNNnxIMGL4McoC12a8gI2g6R8',
      encrypted: false,
      decryptsecret: 'aNq8cL5xAbNNnxIMGL4McoC12a8gI2g6R8',
      encryptedStr: ''
    }
  },
  computed: {
    decrypted: function () {
      return (this.encrypted ? CryptoJS.AES.decrypt(this.encrypted.str, this.decryptsecret).toString(CryptoJS.enc.Latin1) : 'Sorry')
    }
  },
  methods: {
    encrypt: function () {
      let cryptobject = CryptoJS.AES.encrypt(this.plainString, this.encryptsecret)
      this.encrypted = {
        key: cryptobject.key + '', // don't send this
        iv: cryptobject.iv + '', // don't send this
        salt: cryptobject.salt + '', // don't send this
        ciphertext: cryptobject.ciphertext + '', // don't send this
        str: cryptobject + '' // send or store this
      }
    },
    decryptStr () {
      return CryptoJS.AES.decrypt(this.encryptedStr, 'aNq8cL5xAbNNnxIMGL4McoC12a8gI2g6R8').toString(CryptoJS.enc.Latin1)
    },
    encryptData (str = '') {
      return CryptoJS.AES.encrypt(str, this.encryptsecret) + ''
    },
    decryptData (str = '') {
      return CryptoJS.AES.decrypt(str, 'aNq8cL5xAbNNnxIMGL4McoC12a8gI2g6R8').toString(CryptoJS.enc.Latin1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/crypto.js